module.exports = __webpack_public_path__ + "static/media/conciergeLogo.75ca9760.png";